module.exports = __webpack_public_path__ + "static/media/view6.7794ffd4.jpg";